module.exports = __webpack_public_path__ + "static/media/Flower2.1b20a1da.png";